import "../css/moodboard-masonry.css";
import ItemBar from "./ItemBar/ItemBar";

function getTweetId(url) {
  const match = url.match(/status\/(\d+)/);
  return match ? match[1] : null;
}

function TileTwitter({ currentFile, view, rateAssetService, ...props }) {
  const tweetId = getTweetId(currentFile?.fileUrl || "");

  return (
    <div className={`tile ${props.id}`}>
      <ItemBar
        currentFile={currentFile}
        viewItem={() => view(currentFile._id)}
        deleteItem={() => props.delete(currentFile._id)}
        rateAssetService={rateAssetService}
      />
      {tweetId && (
        <iframe
          src={`https://platform.twitter.com/embed/Tweet.html?id=${tweetId}&theme=dark`}
          style={{ width: "100%", minHeight: "400px", border: "none" }}
          allowFullScreen
        />
      )}
    </div>
  );
}

export default TileTwitter;
